// Phone number formatting utilities - exactly 9 digits required
export const formatPhoneNumber = (phoneNumber: string): string => {
  // Remove all non-digit characters
  const cleaned = phoneNumber.replace(/\D/g, '');
  
  // Format exactly 9 digits with spaces in groups of 3
  if (cleaned.length === 9) {
    return `${cleaned.substring(0, 3)} ${cleaned.substring(3, 6)} ${cleaned.substring(6, 9)}`;
  }
  
  // Return original if not exactly 9 digits
  return phoneNumber;
};

export const validatePhoneNumber = (phoneNumber: string): boolean => {
  const cleaned = phoneNumber.replace(/\D/g, '');
  
  // Must be exactly 9 digits
  return cleaned.length === 9;
};

export const normalizePhoneNumber = (phoneNumber: string): string => {
  // Remove all spaces and non-digit characters except keep original if not valid
  const cleaned = phoneNumber.replace(/\s/g, '');
  return cleaned;
};

export const getPhoneValidationError = (phoneNumber: string): string | null => {
  if (!phoneNumber || phoneNumber.trim() === '') {
    return 'Telefonska številka je obvezna';
  }
  
  if (!validatePhoneNumber(phoneNumber)) {
    return 'Telefonska številka mora vsebovati natanko 9 številk';
  }
  
  return null;
};
